import { render, staticRenderFns } from "./ProjectDocumentTemplateNewForm.vue?vue&type=template&id=1792812a&"
import script from "./ProjectDocumentTemplateNewForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentTemplateNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports